function initSafeSleepPanel(scope, $) {
    var $scope = scope ? $(scope) : $(document);

    $scope.find(".safe-sleep").each(function () {
        var $section = $(this);
        var $panel = $section.find(".safe-sleep-panel");

        if (!$panel.length || $section.data("safeSleepBound")) {
            return;
        }
        $section.data("safeSleepBound", true);

        function closePanel() {
            $panel.removeClass("is-open").attr("aria-hidden", "true");
            $("body").removeClass("safe-sleep-panel-open");
        }

        function openPanel($data) {
            if (!$data.length) {
                return;
            }

            $panel.find(".safe-sleep-panel__icon").html($data.find(".safe-sleep__panel-icon").html() || "");
            $panel.find(".safe-sleep-panel__title").html($data.find(".safe-sleep__panel-title").html() || "");
            $panel.find(".safe-sleep-panel__content").html($data.find(".safe-sleep__panel-content").html() || "");

            $panel.addClass("is-open").attr("aria-hidden", "false");
            $("body").addClass("safe-sleep-panel-open");
        }

        $section.on("click", "[data-safe-sleep-open]", function (event) {
            event.preventDefault();
            var $data = $(this).find(".safe-sleep__panel-data").first();
            openPanel($data);
        });

        $section.on("keydown", "[data-safe-sleep-open]", function (event) {
            if (event.key !== "Enter" && event.key !== " ") {
                return;
            }
            event.preventDefault();
            var $data = $(this).find(".safe-sleep__panel-data").first();
            openPanel($data);
        });

        $section.on("click", "[data-safe-sleep-close]", function () {
            closePanel();
        });

        $section.on("click", ".safe-sleep-panel", function (event) {
            if (!$panel.hasClass("is-open")) {
                return;
            }

            if (!$(event.target).closest(".safe-sleep-panel__dialog").length) {
                closePanel();
            }
        });
    });
}

function scrollToSafeSleepSection($) {
    var $target = $(".section-safe-sleep").first();
    if (!$target.length) {
        return;
    }

    $("html, body").stop(true);

    var scrollTop = $target[0].getBoundingClientRect().top + window.pageYOffset - 140;
    window.scrollTo({ top: scrollTop, behavior: "smooth" });
}

function bindCertifiedLabelScroll($) {
    if ($(document).data("certifiedLabelScrollBound")) {
        return;
    }
    $(document).data("certifiedLabelScrollBound", true);

    $(document).on("click", "[data-safe-sleep-scroll]", function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToSafeSleepSection($);
    });
}

function bindSafeSleepEvents($) {
    $(document).ready(function () {
        initSafeSleepPanel(document, $);
        bindCertifiedLabelScroll($);
    });

    document.addEventListener("shopify:section:load", function (event) {
        initSafeSleepPanel(event.target, $);
    });

    $(document).on("keydown", function (event) {
        if (event.key !== "Escape") {
            return;
        }
        $(".safe-sleep-panel.is-open").removeClass("is-open").attr("aria-hidden", "true");
        $("body").removeClass("safe-sleep-panel-open");
    });
}

(function bootstrapSafeSleepScript(retries) {
    var $ = window.jQuery;

    if (!$) {
        if (retries > 0) {
            setTimeout(function () {
                bootstrapSafeSleepScript(retries - 1);
            }, 50);
        }
        return;
    }

    bindSafeSleepEvents($);
})(40);
